import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sl-title',
    templateUrl: './title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf],
})
export class TitleComponent {
	@Input() title: string;
	@Input() hidePendo = false;
}
